import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Avatar from '../Avatar';
import StackView from '../StackView';
import { useHover } from '../hooks';
import CheckboxCell from './CheckboxCell';

function AvatarCell(_ref) {
  var source = _ref.source,
      checked = _ref.checked,
      onChange = _ref.onChange;

  var _useHover = useHover(),
      hover = _useHover.hover,
      hoverProps = _useHover.hoverProps;

  return /*#__PURE__*/React.createElement(StackView, _extends({
    alignment: "center",
    distribution: "center",
    width: 4,
    height: 4
  }, hoverProps), hover || checked ? /*#__PURE__*/React.createElement(CheckboxCell, {
    onChange: onChange,
    checked: checked
  }) : /*#__PURE__*/React.createElement(Avatar, {
    source: source,
    size: "sm"
  }));
}

export default AvatarCell;